import React, { useEffect } from 'react';
import { StyleSheet, View, Text } from 'react-native';
import { useMediaQuery } from 'react-responsive';

import Button from 'shared/modules/common/components/atoms/Button';
type Props = {
  onReturnButtonPress: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
};

const LiquidTerms = (props: Props) => {
  const isBigScreen = useMediaQuery({ minWidth: 768 });
  const { onReturnButtonPress, onFocus, onBlur } = props;

  useEffect(() => {
    onFocus?.();

    return () => onBlur?.();
  }, []);

  return (
    <View style={styles.root}>
      <Text style={styles.mainTitle}>{`本人確認サービス利用規約`}</Text>
      <View style={styles.contentContainer}>
        <View style={styles.contentBody}>
          <Text style={styles.contentBodyText}>
            {`株式会社Paidyに代わって株式会社Liquid※\nが、本人認証サービスを提供いたします。\n\n`}
          </Text>
          <Text style={styles.contentBodyText}>
            {`※株式会社Liquidは、2020年11月1日を以て株式会社ELEMENTSから会社分割により生体認証事業を承継した会社となります。\n\n`}
          </Text>
          <Text style={styles.contentBodyText}>
            {`なお、本人認証サービス（以下、本サービス）において使用する個人情報の利用目的は以下の通りです。詳細について、下記の利用規約を最後までお読みになり、下のボタンから次へお進みください。
・当社が本サービスを提供するため
・本サービス提供に付随する本人認証、認証のため
・当社の技術開発（顔認証エンジン機械学習・ランダムアクション自動判定機械学習・偽造書類、なりすまし登録検知のための機械学習、不正登録検知を含みます）のため
・上記に付随するアフターサービス、問い合わせ、苦情対応のため
・上記利用目的の達成のため、個人情報や個人データを第三者に提供するため`}
          </Text>
        </View>
      </View>
      <View style={[styles.buttonContainer, isBigScreen && { paddingTop: 60 }]}>
        <Button
          onPress={onReturnButtonPress}
          title="戻る"
          variant="outlined"
          style={styles.returnButton}
          id="ekyc-liquid-terms-return-button"
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  root: {
    flexDirection: 'column',
    flexGrow: 1,
  },
  mainTitle: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 24,
    color: '#000',
  },
  buttonContainer: {
    flexDirection: 'column',
    flex: 1,
    flexGrow: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingTop: 24,
  },
  returnButton: {
    paddingVertical: 8,
    paddingHorizontal: 8,
  },
  contentContainer: {
    borderRadius: 12,
    backgroundColor: '#fff',
  },
  contentBody: {
    padding: 16,
  },
  contentBodyText: {
    fontWeight: '300',
    fontSize: 16,
    color: '#1C1C1C',
  },
});

export default LiquidTerms;
